import { Component, Input, OnInit} from '@angular/core';
import { ICartItem, ISearchMaskOccupancy, ISearchParams, IShopCart } from 'core-lib';
import { DatePipe } from '@angular/common';
import { ImageGallery1Component } from "../image-gallery1/image-gallery1.component";
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { TabsModule } from 'primeng/tabs';
import { SettingsService } from 'core-lib';
import { ShopcartService } from 'core-lib';
import { DisplayPricePipe } from '../../pipes/displayPrice';
import { formatRateNamePipe } from "../../pipes/format-rate-name.pipe";

@Component({
    selector: 'app-profile-summary',
    imports: [DatePipe, DisplayPricePipe, ImageGallery1Component, ButtonModule, TranslateModule, TabsModule, formatRateNamePipe],
    templateUrl: './profile-summary.component.html',
    styleUrl: './profile-summary.component.scss'
})
export class ProfileSummaryComponent implements OnInit {

  @Input() shopCart:IShopCart;
  @Input() searchParams:ISearchParams|null;
  rooms:ICartItem[];
  totalOccupancy: ISearchMaskOccupancy;

  constructor(public settings: SettingsService, public shopCartService: ShopcartService) {}

  ngOnInit() {
    this.calculateTotalOccupancy();
    this.rooms = this.shopCart?.getCartItemsByType('roomrate');
  }

  calculateTotalOccupancy() {
    if (this.searchParams) {
      let roomData = this.searchParams?.roomData;
      let rooms = roomData?.length ?? 0;
      let adults: number = 0;
      let children: number = 0;
      roomData?.forEach(r => {
        adults += r.adults;
        children += r.children;
      });
      this.totalOccupancy = {
        rooms: rooms,
        adults: adults,
        children: children
      }

    }
    
  }

}
